import OpenAI from 'openai';
import { OPENAI_CONFIG, SYSTEM_PROMPT } from '../config/ai';

class AIService {
  private openai: OpenAI;
  private context: any[] = [];

  constructor() {
    this.openai = new OpenAI({
      apiKey: OPENAI_CONFIG.apiKey,
      dangerouslyAllowBrowser: true
    });
  }

  private async chat(messages: any[]) {
    try {
      const response = await this.openai.chat.completions.create({
        model: OPENAI_CONFIG.model,
        messages,
        temperature: OPENAI_CONFIG.temperature,
        max_tokens: OPENAI_CONFIG.maxTokens,
      });

      return response.choices[0].message.content;
    } catch (error) {
      console.error('OpenAI API Error:', error);
      throw new Error('Failed to get AI response');
    }
  }

  async processMessage(message: string) {
    const messages = [
      { role: 'system', content: SYSTEM_PROMPT },
      ...this.context,
      { role: 'user', content: message }
    ];

    const response = await this.chat(messages);
    
    // Update context with the new interaction
    this.context.push(
      { role: 'user', content: message },
      { role: 'assistant', content: response }
    );

    // Keep context manageable by limiting to last 10 messages
    if (this.context.length > 10) {
      this.context = this.context.slice(-10);
    }

    return response;
  }

  async analyzeFinancialData(data: any) {
    const prompt = `Please analyze this financial data and provide insights:
    ${JSON.stringify(data)}
    
    Focus on:
    1. Key trends and patterns
    2. Areas of concern or opportunity
    3. Actionable recommendations
    4. Budget optimization suggestions`;

    return this.processMessage(prompt);
  }

  async suggestProductivityImprovements(metrics: any) {
    const prompt = `Based on these productivity metrics:
    ${JSON.stringify(metrics)}
    
    Please suggest:
    1. Areas for workflow optimization
    2. Time management improvements
    3. Task prioritization strategies
    4. Automation opportunities`;

    return this.processMessage(prompt);
  }

  async generateHealthInsights(healthData: any) {
    const prompt = `Analyze this health data:
    ${JSON.stringify(healthData)}
    
    Provide insights on:
    1. Health trends and patterns
    2. Areas needing attention
    3. Lifestyle improvement suggestions
    4. Wellness goals and recommendations`;

    return this.processMessage(prompt);
  }
}

export const aiService = new AIService();